import { render, staticRenderFns } from "./profileView.vue?vue&type=template&id=af5187de&scoped=true&"
import script from "./profileView.vue?vue&type=script&lang=js&"
export * from "./profileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5187de",
  null
  
)

export default component.exports